// bottomSheetContent.styles.ts

import styled from "styled-components";

export const BottomSheetContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%; /* 부모 요소의 전체 높이를 차지하도록 설정 */
`;

export const BottomSheetTop = styled.div`
  flex-shrink: 0; /* 고정 높이를 유지하도록 설정 */
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 1.6rem;
  font-weight: 500;
`;

export const BottomSheetFilter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-left: 24px;
`;

export const BottomSheetSelect = styled.div`
  flex: 1; /* 남은 공간을 모두 차지하도록 설정 */
  overflow-y: auto; /* 세로 스크롤 가능하도록 설정 */
  -webkit-overflow-scrolling: touch; /* 모바일에서 부드러운 스크롤 */
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px;

  p {
    font-size: 1.8rem;
  }
`;

export const BottomSheetSelectDetailBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const BottomSheetSelectBodyBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const BottomSheetSelectDetail = styled.div<any>`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 4px;

  &.workPoint {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const BottomSheetButtonBox = styled.div`
  flex-shrink: 0; /* 고정 높이를 유지하도록 설정 */
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 12px;

  .small {
    width: 50%;
  }
`;
